<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Edit Backup Location</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="backup_location.name">
          </div>
          <div class="form-group">
            <label for="ddlLocationType">Location Type</label>
            <select class="form-control" id="ddlLocationType" v-model="backup_location.backup_location_type_id">
              <option v-for="backup_location_type in backup_location_types"
                      :key="backup_location_type.backup_location_type_id"
                      v-bind:value="backup_location_type.backup_location_type_id">{{ backup_location_type.name
                }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="txtPath">Folder Path</label>
            <input type="text" class="form-control" id="txtPath" v-model="backup_location.path">
            <small class="form-text text-muted">Path from root folder. Cannot contain spaces.</small>
          </div>
          <div v-if="showLoginCred">
            <div class="form-group">
              <label for="txtServer">Server (IP or URL)</label>
              <input type="text" class="form-control" id="txtServer" v-model="backup_location.server">
              <small class="form-text text-muted">No slashes or http.</small>
            </div>
            <div class="form-group">
              <label for="txtUsername">Username</label>
              <input type="text" class="form-control" id="txtUsername" v-model="backup_location.username">
            </div>
            <div class="form-group">
              <label for="txtPassword">Password</label>
              <input type="password" class="form-control" id="txtPassword" v-model="backup_location.password">
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminBARLocationsIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'backup_location_id'
  ],
  computed: {
    showLoginCred () {
      return [2, 3].includes(this.backup_location.backup_location_type_id)
    },
    ...mapGetters({
      backup_location: 'singleBackupLocation',
      backup_location_types: 'allBackupLocationTypes'
    })
  },
  created () {
    this.$store.dispatch('getBackupLocationTypes')
    this.$store.dispatch('getBackupLocation', this.backup_location_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditBackupLocation', this.backup_location)
    }
  }
}
</script>

<style scoped>

</style>
